<template>
	<div class="tag-icon-item small-sm-text" @click.stop="onClick">
		<span class="tag-icon-wrap" :class="{ active: isActiveItem }">
			<SVGIcon class="tag-icon" :icon-name="tag.icon" width="37" height="37" />
		</span>
		<div class="tag-icon-type mt-10 text-center">
			{{ capitalize(tag.name) }}
		</div>
	</div>
</template>

<script>
import { capitalize } from '~/assets/util/helpers'
import SVGIcon from '~/components/interface/SVGIcon'

export default {
	name: 'TagIconItem',
	components: { SVGIcon },
	props: {
		tag: {
			type: Object,
			required: true
		},
		selectedTagType: {
			type: String,
			default: null
		}
	},
	computed: {
		isActiveItem () {
			return this.tag.type === this.selectedTagType
		}
	},
	methods: {
		capitalize,

		onClick (type) {
			this.$emit('update:selected-tag-type', this.tag.type)
		}
	}
}
</script>

<style lang="scss">
.tag-icon-item {
  width: 50px;
  margin: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .tag-icon-type {
    color: $white;
    opacity: 0.7;
  }

  .tag-icon-wrap {
    border: solid 0.9px #4b4b4b;
    border-radius: 50%;
    width: 37px;
    height: 37px;
    display: flex;
    justify-content: center;
    align-items: center;

    .tag-icon {
      filter: invert(0.5);
      cursor: pointer;
      svg {
        display: flex;
      }
    }

    &:hover,
    &.active {
      border: solid 0.9px #a5d6ed;
      transform: scale(1.05);
      transition: 0.3s ease-in-out;
      .tag-icon {
        filter: invert(1);
        transition: 0.3s ease-in-out;
      }
    }
  }
}
</style>
